module.exports = __webpack_public_path__ + "img/a1.4d722a7b.jpg";